<div class="content-header bg-primary">
  <mat-toolbar class="px-2 page-header-toolbar dashboard-toolbar-flex">
    <div class="dashboard-toolbar-title w-100">
      @if (isRetailerUser()) {
        <h1>
          {{ dashboardTitle || 'All Retailers' }}
        </h1>
      }
      @if (!isRetailerUser()) {
        <div class="w-100">
          <cdui-filter-well (onFilterChange)="onSelectedFilterChange($event)" (onFilterReset)="onFilterReset($event)"
            (onToolbarInitialized)="onFilterWellInitialized($event)">
          </cdui-filter-well>
        </div>
      }
    </div>

    <div class="dashboard-toolbar-actions right-spacing-sidebar-collapsed">
      <mat-form-field appearance="outline" class="app-form-field dashboard-date-form-field">
        <mat-select [(value)]="selectedMonthOrRange">
          <mat-select-trigger>
            {{ selectedMonthOrRange.label }}
          </mat-select-trigger>
          @for (month of months; track month) {
          <mat-option [value]="month" (click)="changeMonth(month)">{{ month.label }}</mat-option>
          }
          <mat-option id="customDateRange" [value]="customDateRange" (click)="changeMonth('custom')">Custom</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </mat-toolbar>

  <div class="content-wrapper p-2">
    <div class="dashboard-billboard-row">
      <div class="dashboard-billboard-col" [@animate]="billboardAnimation">
        <dashboard-billboard-chart [billboardChartInfo]="timeSavedBillboardChart"></dashboard-billboard-chart>
      </div>
      <div class="dashboard-billboard-col" [@animate]="billboardAnimation">
        <dashboard-billboard-chart [billboardChartInfo]="billableMinutesBillboardChart"></dashboard-billboard-chart>
      </div>
      <div class="dashboard-billboard-col" [@animate]="billboardAnimation">
        <dashboard-billboard-chart [billboardChartInfo]="appointmentsBillboardChart"></dashboard-billboard-chart>
      </div>
      <div class="dashboard-billboard-col" [@animate]="billboardAnimation">
        <dashboard-billboard-chart [billboardChartInfo]="followUpsBillboardChart"></dashboard-billboard-chart>
      </div>
    </div>
    <div class="dashboard-card-row">
      <div class="dashboard-card-col">
        <dashboard-card-chart [chartInfo]="breakdownChart"></dashboard-card-chart>
      </div>
      <div class="dashboard-card-col">
        <dashboard-card-chart [chartInfo]="callVolumeChart"></dashboard-card-chart>
      </div>
    </div>
    <div class="dashboard-call-stream-row">
      <dashboard-call-stream style="width: 100%"></dashboard-call-stream>
    </div>
  </div>
</div>